const WeeklyEvents = ({ children }) => {
    return (
        <div className="main-content__calendar-events-weekly">
            <div className="calendar-weekly-table">
                {children}
            </div>
        </div>
    );
};

export default WeeklyEvents;
